module.exports = "https://pp-webapp-deployment.parcelperform.com/pp-portal/5f8326af/pp-asset/image/public/images/icons/add-parcel.svg"